/**
 * Directive: resourceTypeEdit
 */
angular.module('acme.common.directive.resourceTypeEdit', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.integer',
  'acme.common.directive.signButton'
])
  .directive('resourceTypeEdit', [function () {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceType/edit/edit.tpl.html',
      scope: {
        toggle: '=',
        model: '=',
        state: '@',
        resourceIndex: '@resourceindex',
        disableActions: '@disableactions',
        index: '=',
        showHeader: '=showheader'
      },
      link: function ($scope, $element, $attrs) {
        // Modified after controller runs
        console.log($scope.toggle);
        $scope.$watch('model', $scope.resourceTypeEdit.onModelUpdate);
      },

      controller: ['$scope', 'ApiService', 'HelpersService', function ($scope, ApiService, HelpersService) {

        $scope.resourceTypeEdit = {

          templateId: -1,
          showHeader: true,
          model: {},
          selectedFields: [],
          selectableFields: [],
          selectableFieldValues: [],
          selectableFieldNames: [],
          currentFieldNames: [],
          currentFieldValues: [],

          init: function () {
            if ($scope.model && $scope.model.hasOwnProperty('resourceTemplateId')) {
              this.templateId = $scope.model.resourceTemplateId;
            }

            if (this.templateId && this.templateId !== -1) {
              console.log('resourceTypeEdit::init', this.templateId);
              this.getResource(this.templateId);
            }

            console.log('resourceTypeEdit', $scope.showHeader);

          },

          remove: function() {
            $scope.$emit('resourceTypeEdit::remove', this.model);
          },

          fieldList : function(field) {
            var r = [],
                list = HelpersService.getFieldValue(field);

            if (list instanceof Array) {
              r = list;
            }else if (list) {
              r = [list];
            }

            console.log('resourceTypeEdit::fieldList', field, r);
            return r;
          },

          hasModelFields: function() {
            return (this.model.fields && this.model.fields.length > 0);
          },

          addField: function() {
            this.selectedFields.push([{
              name: '',
              value: ''
            }]);
          },

          removeField: function(index) {
            console.log('resourceTypeEdit::removeField', index);
            this.selectedFields.splice(index, 1);
            this.currentFieldValues.splice(index, 1);
            this.currentFieldNames.splice(index, 1);
            this.save();
          },

          getResource: function (id) {
            ApiService.resource.detail(id).then(this.success.getResource, this.error.getResource);
          },

          getFieldValues: function(fieldName) {
            var i, ii,
                r = [];

            for (i=0,ii=this.model.srcFields.length;i<ii;i++) {
              if (fieldName === this.model.srcFields[i].name) {
                r = this.fieldList(this.model.srcFields[i]);
                break;
              }
            }

            if (typeof(r[0]) !== 'string') {
              console.log('resourceTypeEdit::getFieldValues !string', r[0]);
              for (i=0,ii=r.length;i<ii;i++) {
                r[i] = r[i].toString();
              }
            }
            console.log('resourceTypeEdit::getFieldValues', r);


            return r;
          },

          selectFieldName: function(index) {

            this.selectedFields[index].name = this.currentFieldNames[index];
            this.selectableFieldValues[this.selectedFields[index].name] = this.getFieldValues(this.currentFieldNames[index]);
            this.save();

            console.log('selectFieldName', index, this.selectableFieldValues[index], this.currentFieldNames[index]);
          },

          selectFieldValue: function(index) {
            this.save();
          },

          hasFieldValues: function(fieldName) {
            var len = false;
            console.log('resourceTypeEdit::hasFieldValues', fieldName, this.selectableFieldValues[fieldName]);
            if (this.selectableFieldValues.hasOwnProperty(fieldName)) {
              len = this.selectableFieldValues[fieldName].length;
            }

            return len;
          },

          hasSelectableFields: function() {
            return (this.selectableFieldNames.length > 0);
          },

           /**selectedFieldValue: function(index, value) {
            var i, ii;

            for (i=0,ii=this.model.fields.length;i<ii;i++) {
              if (this.model.fields[i].name === this.model.srcFields[index].name) {
                this.model.fields[i].value = this.selectedFields[index];
                
                break;
              }
            }

            console.log('selectedFieldValue', this.model, $scope.model);

          },*/

          view: function() {
            $scope.$emit('resourceType::stateChange', {
              state: 'view'
            });
          },

          save: function() {
            var i, ii,
              fields = [];

            for (i=0,ii=this.currentFieldNames.length;i<ii;i++) {
              fields.push({
                name: this.currentFieldNames[i],
                value: this.currentFieldValues[i]
              });
            }

            console.log('resourceTypeEdit::save', fields);
            $scope.$emit('resourceTypeEdit::save', {
              type: $scope.model.type,
              quantity: $scope.resourceTypeEdit.model.quantity,
              resourceTemplateId: $scope.model.id,
              fields: fields
            });

          },

          success: {
            getResource: function (response, status, headers, config) {
              console.log("resourceTypeEdit::success::getResource", response.data.resourceType.fields);
              $scope.resourceTypeEdit.model.srcFields = response.data.resourceType.fields;
            }
          },

          error: {
            getResource: function (response, status, headers, config) {
            }
          },

          onModelUpdate: function(model) {
            var i, ii,
                list = {};

            console.log('resourceTypeEdit::onModelUpdate', model);
            $scope.resourceTypeEdit.model = model;

            angular.copy($scope.resourceTypeEdit.model.fields, $scope.resourceTypeEdit.selectedFields);

            // Only add source fields which have selectable values
            for (i = 0, ii = $scope.resourceTypeEdit.model.srcFields.length; i < ii; i++) {
              list = $scope.resourceTypeEdit.fieldList($scope.resourceTypeEdit.model.srcFields[i]);
              if (list.length > 0) {
                $scope.resourceTypeEdit.selectableFieldNames.push($scope.resourceTypeEdit.model.srcFields[i].name);
                $scope.resourceTypeEdit.selectableFieldValues[$scope.resourceTypeEdit.model.srcFields[i].name] = $scope.resourceTypeEdit.getFieldValues($scope.resourceTypeEdit.model.srcFields[i].name);
              }
            }

            // Initialize from existing field values
            console.log('onModelUpdate', $scope.resourceTypeEdit.selectableFieldNames, $scope.resourceTypeEdit.selectedFields);
          }

        };

        $scope.resourceTypeEdit.init();
      }]
    };

  }]);